import { render, staticRenderFns } from "./CertificiranjePDF.vue?vue&type=template&id=16f48e38&scoped=true&"
import script from "./CertificiranjePDF.vue?vue&type=script&lang=js&"
export * from "./CertificiranjePDF.vue?vue&type=script&lang=js&"
import style0 from "./CertificiranjePDF.vue?vue&type=style&index=0&id=16f48e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f48e38",
  null
  
)

export default component.exports